class SignupFormatting {
  constructor($timeout) {
    this.$timeout = $timeout;
  }

  parsePhone(phoneNum) {
    phoneNum = phoneNum.replace("+1", "").trim();
    let phoneNumber = "1" + phoneNum;
    return phoneNumber.replace(/\D/g, "");
  }

  phoneFormatting(vm) {
    return {
      prefix: "+1 ",
      phone: true,
      phoneRegionCode: "us",
      delimiter: "-",
      rawValueTrimPrefix: true,
      onValueChanged: (e) => {
        vm.phone_number = e.target.rawValue.trim();

        // Prevent formatting error from starting number with 1
        if (vm.phone_number.length === 1 && [1, "1"].indexOf(vm.phone_number) !== -1) {
          vm.$timeout(() => {
            vm.phone_number = "";
            vm.display_phone_number = "";
          });
        }

        vm.validator.phone(vm.phone_number, vm);
      },
    };
  }

  phoneFormattingOnboarding(vm) {
    return {
      prefix: "+1 ",
      phone: true,
      phoneRegionCode: "us",
      delimiter: "-",
      rawValueTrimPrefix: true,
      onValueChanged: (e) => {
        vm.onboarding_data.phone_number = e.target.rawValue.trim();

        // Prevent formatting error from starting number with 1
        if (vm.onboarding_data.phone_number.length === 1 && [1, "1"].indexOf(vm.onboarding_data.phone_number) !== -1) {
          vm.$timeout(() => {
            vm.onboarding_data.phone_number = "";
            vm.onboarding_data.display_phone_number = "";
          });
        }
      },
    };
  }
}

SignupFormatting.$inject = ["$timeout"];

export default SignupFormatting;



// WEBPACK FOOTER //
// ./client/app/scenes/signup/services/format.js